<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div ref="app-sidepanel" class="app-sidepanel" :class="isOpen ? 'app-sidepanel sidepanel-visible' : 'app-sidepanel sidepanel-hidden'">
    <div id="sidepanel-drop" class="sidepanel-drop"></div>
    <div class="sidepanel-inner d-flex flex-column">
      <a href="#" id="sidepanel-close" @click.prevent="sideClose" class="sidepanel-close d-xl-none">&times;</a>
      <div class="app-branding">
        <router-link class="app-logo" :to="{name:'Index'}"><img class="me-2" src="@/assets/images/logo-aff-simple.png" alt="logo">
        </router-link>

      </div><!--//app-branding-->

      <nav id="app-nav-main" class="app-nav app-nav-main flex-grow-1">

        <ul class="app-menu list-unstyled accordion" id="menu-accordion" v-if="!isLoggedIn">
          <NavItem :route="{name:'Login'}">
            <template #text>
              Login
            </template>
            <template #icon>
              <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-house-door" fill="currentColor"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                      d="M7.646 1.146a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 .146.354v7a.5.5 0 0 1-.5.5H9.5a.5.5 0 0 1-.5-.5v-4H7v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .146-.354l6-6zM2.5 7.707V14H6v-4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4h3.5V7.707L8 2.207l-5.5 5.5z"/>
                <path fill-rule="evenodd" d="M13 2.5V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
              </svg>
            </template>
          </NavItem>
        </ul>

        <ul class="app-menu list-unstyled accordion" id="menu-accordion2" v-else>



<!--          <NavItem :route="">
            <template #text></template>
            <template #icon>

            </template>
          </NavItem>-->

          <NavItem :route="{name:'Streams'}">
            <template #text>Streams List</template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stack" viewBox="0 0 16 16">
                <path d="m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.598.598 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535L7.733.063z"/>
                <path d="m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z"/>
              </svg>
            </template>
          </NavItem>

          <NavItem :route="{name:'Index'}" v-if="isStreamSelected">
            <template #text>{{currentStream?.description}}</template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-layers-fill" viewBox="0 0 16 16">
                <path d="M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882l7.5-4z"/>
                <path d="m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0l-5.17-2.756z"/>
              </svg>
            </template>
          </NavItem>

          <NavItem has-opened v-if="isStreamSelected">
            <template #text>Stream Settings</template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-toggle-on" viewBox="0 0 16 16">
                <path d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"/>
              </svg>
            </template>
            <template #subitems>
              <SubItem :route="{name:'Limits'}" text="Limits & Filters"></SubItem>
              <SubItem :route="{name:'Offers'}" text="Offers"></SubItem>
              <SubItem :route="{name:'Postback'}" text="Postback"></SubItem>
            </template>
          </NavItem>

          <NavItem has-opened v-if="isStreamSelected">
            <template #text>Stream Statistic</template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-journals" viewBox="0 0 16 16">
                <path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2z"/>
                <path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0z"/>
              </svg>
            </template>
            <template #subitems>
              <SubItem :route="{name:'Earnings'}" text="Earning Details"></SubItem>
              <SubItem :route="{name:'Balance'}" text="Balance Details"></SubItem>
            </template>
          </NavItem>


          <NavItem :route="{name:'Program'}">
            <template #text>About Program</template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
              </svg>
            </template>
          </NavItem>

          <NavItem :route="{name:'Promo'}">
            <template #text>Promo materials</template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-collection-play-fill" viewBox="0 0 16 16">
                <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm6.258-6.437a.5.5 0 0 1 .507.013l4 2.5a.5.5 0 0 1 0 .848l-4 2.5A.5.5 0 0 1 6 12V7a.5.5 0 0 1 .258-.437z"/>
              </svg>
            </template>
            <!--            <template #subitems>
                          <SubItem :route="{name:'Limits'}" text="Limits & Filters"></SubItem>
                          <SubItem :route="{name:'Offers'}" text="Offers"></SubItem>
                          <SubItem :route="{name:'Postback'}" text="Postback"></SubItem>
                        </template>-->
          </NavItem>


        </ul>
      </nav><!--//app-nav-->

      <div class="app-sidepanel-footer">
        <nav class="app-nav app-nav-footer">
          <ul class="app-menu footer-menu list-unstyled">
            <NavItem has-opened :route="{name:'Withdraw'}">
              <template #text>Earning</template>
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     class="bi bi-cash-coin" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"/>
                  <path
                      d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"/>
                  <path
                      d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"/>
                  <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"/>
                </svg>
              </template>
              <template #subitems>
                <SubItem :route="{name:'Withdraw'}" text="Withdraw"></SubItem>
                <SubItem :route="{name:'Withdraws'}" text="Withdrawal history"></SubItem>
              </template>
            </NavItem>

            <NavItem :route="{name:'Login'}">
              <template #text>Logout</template>
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                  <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
                </svg>
              </template>
            </NavItem>
          </ul><!--//footer-menu-->
        </nav>
      </div>

    </div><!--//sidepanel-inner-->
  </div><!--//app-sidepanel-->
</template>

<script>
import {isLoggedIn, isStreamSelected, currentStream} from "@/inc/storage";
import NavItem from "@/components/menu/NavItem";
import SubItem from "@/components/menu/SubItem";

export default {
  name: "SidePanel",
  components: {SubItem, NavItem},
  props : {
    isOpen : { type: Boolean, default : false }
  },
  methods : {
    sideClose : function ()
    {
      this.$emit('doclose')
    }
  },
  setup()
  {
    return {
      isLoggedIn, isStreamSelected, currentStream
    }
  },
}
</script>

<style scoped>

</style>